export class URLRedirects extends HTMLElement {
  constructor(dni_campaign_parameter_targets) {
    super();
    this.dni_campaign_parameter_targets = dni_campaign_parameter_targets
  }
  connectedCallback() {
    this.innerHTML = 
      `<label>URL Redirect</label>
        <div>
          <div class="row">
            <span class="col-sm-6 no-gutters">Calls made to matching URL parameter names and values will be redirected to the appropriate Number/Treatment.</span>
            <div class="col-sm-6"><button class="btn btn-outline-primary pull-left" id="url-redirect-btn">Add new URL</button></div>
          </div>
          <div class="errors"></div>
        </div>
        <div class="url_redirect_container"></div>`;

      this.dni_campaign_parameter_targets.forEach((dni_campaign_parameter_target) => {
        let redirectForm = new URLRedirectForm(dni_campaign_parameter_target);
        this.querySelector('.url_redirect_container').appendChild(redirectForm);
      })    
      if(this.dni_campaign_parameter_targets.length > 0) {
        this.querySelector('#url-redirect-btn').classList.add('hidden');
      }

      this.querySelector('#url-redirect-btn').addEventListener('click', function(e) {
        e.preventDefault()
        this.querySelector('#url-redirect-btn').classList.add('hidden');
        let redirectForm = new URLRedirectForm();
        this.querySelector('.url_redirect_container').appendChild(redirectForm);
      }.bind(this))
  }

  validate() {
    let isValid = true;
    let errors = "";
    let redirect_values = [];
    let name_exists = true;
    let number_exists = true;
    let treatment_exists = true;
    // Validates name field
    this.querySelectorAll('.dni-url-redirect-parameter-name').forEach(elem => {
      if(!elem.value.trim()) {
        name_exists = false;
        elem.classList.add('error');
      }
    })
    if(name_exists == false) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert" style="margin-top:4px">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please provide a URL Redirect name.
                  </div>`;
      isValid = false;
    }
    //Validates duplicate name/value pairs
    this.querySelectorAll('.url-redirect-row').forEach(elem => redirect_values.push(`${elem.querySelector('.dni-url-redirect-parameter-name').value}_${elem.querySelector('.dni-url-redirect-parameter-value').value}`));
    let duplicates = redirect_values.reduce(function(acc, el, i, arr) {
      if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el); return acc;
    }, []);
    if(duplicates.length > 0) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> URL Redirect name/value pairings must be unique.
                  </div>`;
      isValid = false;
    }
    // Validates alternative number or call treatment fields
    this.querySelectorAll('url-redirect-form').forEach(elem => {
      if(!elem.validateNumber()) {
        number_exists = false;
        elem.querySelector('.ring_to_endpoint').classList.add('error');
      }
      if(!elem.validateTreatment()) {
        treatment_exists = false;
        elem.querySelector('.call_treatment').classList.add('error');
      }
    })
    if(number_exists == false) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please provide a valid phone number.
                  </div>`;
      isValid = false;
    }
    if(treatment_exists == false) {
      errors += `<div class="alert alert-danger alert-dismissible" role="alert">
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <strong>Warning!</strong> Please select a call treatment.
                  </div>`;
      isValid = false;
    }

    this.querySelector('.errors').innerHTML = errors;

    return isValid
  }
}

customElements.define('url-redirects', URLRedirects)

class URLRedirectForm extends HTMLElement {
  constructor(dni_campaign_parameter_redirect = null) {
    super();
    this.dni_campaign_parameter_redirect = dni_campaign_parameter_redirect
  }
  connectedCallback() {
    this.url_redirect_container = this.closest(".url_redirect_container")
    let url_redirect_class = `url-redirect-toggle-${new Date().getTime()}`;
    this.innerHTML = 
    `<style>
      #url-redirect-radio {
        margin-top: 10px;
      }
      #url-redirect-radio * {
        display: inline-block;
      }
      #url-redirect-radio label {
        margin-right: 10px;
      }
      .url-redirect-row {
        margin-bottom:5px;
        position:relative;
      }
    </style>
    <div class="row url-redirect-row">
      <div class="col-md-10 no-gutters">
        <div class="col-md-6">
          <label>Param Name</label>
          <input type="text" class="dni-url-redirect-parameter-name form-control" placeholder="Required" value="${this.dni_campaign_parameter_redirect != null ? this.dni_campaign_parameter_redirect.url_parameter_name : ""}">
        </div>
        <div class="col-md-6">
          <label>Param Value</label>
          <input type="text" class="dni-url-redirect-parameter-value form-control" value="${this.dni_campaign_parameter_redirect != null && this.dni_campaign_parameter_redirect.url_parameter_value ? this.dni_campaign_parameter_redirect.url_parameter_value : ""}">
        </div>
        <div class="col-md-12" id="url-redirect-radio">
          <input type="radio" name="${url_redirect_class}" id="alt-number-radio" data-cy="alt-number-radio" checked ${this.dni_campaign_parameter_redirect != null && this.dni_campaign_parameter_redirect.target.target_type == 'DEFAULT' ? 'checked' : ''}>
          <label>Alternative Number</label>
          <input type="radio" name="${url_redirect_class}" id="url-call-treat-radio" data-cy="url-call-treat-radio" ${this.dni_campaign_parameter_redirect != null && this.dni_campaign_parameter_redirect.target.target_type == 'TREATMENT' ? 'checked' : ''}>
          <label>Call Treatment</label>
        </div>
        <div class="col-md-12">
          <input type="text" is="ring-to-endpoint" class="form-control ring_to_endpoint ${this.dni_campaign_parameter_redirect == null || this.dni_campaign_parameter_redirect.target.target_type == 'DEFAULT' ? "" : "hidden"}" id="url-redirect-rtn" data-cy="url-redirect-rtn" data-key="ring_to_endpoint" placeholder="(123)444-XXXX" value="${this.dni_campaign_parameter_redirect != null && this.dni_campaign_parameter_redirect.target.target_type == 'DEFAULT' ? this.dni_campaign_parameter_redirect.target.children[0].destination.ring_to_endpoint : ''}">
          <select is=treatments-select class="form-control call_treatment ${this.dni_campaign_parameter_redirect != null && this.dni_campaign_parameter_redirect.target.target_type == 'DEFAULT' ? "hidden" : ""}" data-cy="url-call-treat-id" data-selected="${this.dni_campaign_parameter_redirect != null && this.dni_campaign_parameter_redirect.target.target_type == 'TREATMENT' ? this.dni_campaign_parameter_redirect.target.target_id : null}"></select>
        </div>
      </div>
      <div class="col-md-2 dni-url-add" style="line-height:30px;">
        <a class="remove_row"><span class="fa fa-minus"></span></a>
        <a class="add_row"><span class="fa fa-plus"></span></a>
      </div>
    </div>`;

    if(this.querySelector('#alt-number-radio').checked == true) {
      this.querySelector('.call_treatment').classList.add('hidden');
    }

    this.querySelector('.add_row').addEventListener('click', this.addRow.bind(this))
    this.querySelector('.remove_row').addEventListener('click', this.removeRow.bind(this))

    this.querySelector('#alt-number-radio').addEventListener('click', function() {
      this.querySelector('.call_treatment').classList.add('hidden');
      this.querySelector('#url-redirect-rtn').classList.remove('hidden');
    }.bind(this))
    this.querySelector('#url-call-treat-radio').addEventListener('click', function() {
      this.querySelector('#url-redirect-rtn').classList.add('hidden');
      this.querySelector('.call_treatment').classList.remove('hidden');
    }.bind(this))
  }
  addRow() {
    let redirectForm = new URLRedirectForm();
    this.url_redirect_container.appendChild(redirectForm);
  }

  removeRow() {
    this.url_redirect_container.removeChild(this)

    if(this.url_redirect_container.childNodes.length == 0) {
      document.querySelector('#url-redirect-btn').classList.remove('hidden');
    }
  }

  getData() {
    let target = {};
    if(this.querySelector('#url-call-treat-radio').checked == true) {
      target.target_id = this.querySelector('.call_treatment').value;
    } else {
      let ring_to = this.querySelector('.ring_to_endpoint').value.split("@");
      if(ring_to.length == 1) {
         target.ring_to_number = ring_to[0].replace(/\D/g,'');
         target.ring_to_domain = null;
      } else {
         target.ring_to_number = ring_to[0].replace(/\D/g,'');
         target.ring_to_domain = ring_to[1]
      }
    }
    return {
      dni_campaign_parameter_target_id: this.dni_campaign_parameter_redirect != null ? this.dni_campaign_parameter_redirect.dni_campaign_parameter_target_id : null,
      url_parameter_name: this.querySelector(".dni-url-redirect-parameter-name").value,
      url_parameter_value: this.noEmptyString(this.querySelector(".dni-url-redirect-parameter-value").value),
      target: target,
    }
  }

  validateNumber() {
    if(this.querySelector('#alt-number-radio').checked && !this.querySelector('.ring_to_endpoint').value) {
      return false;
    }
    return true;
  }

  validateTreatment() {
    if(this.querySelector('#url-call-treat-radio').checked && !this.querySelector('.call_treatment').value) {
      return false;
    }
    return true;
  }

  noEmptyString(val) {
    return val && val.trim().length > 0 ? val.trim() : null;
  }
}

customElements.define('url-redirect-form', URLRedirectForm)